/**
 * 预览字幕 Tab：语言代码 → 中文名称（与平台语言配置一致）
 * 用于 HLS track.language、接口 subtitles[].language 等
 */

export const SUBTITLE_LANGUAGE_LABEL_MAP = {
  zh_CN: '中文',
  en_US: '英语',
  ko_KR: '韩语',
  ja_JP: '日语',
  es_ES: '西语',
  th_TH: '泰语',
  zh_HK: '繁中',
  id_ID: '印尼',
  pt_PT: '葡语',
  tr_TR: '土耳其',
  fr_FR: '法语',
  ar_AE: '阿拉伯',
  de_DE: '德语',
  vi_VN: '越南语'
}

/** 常见简写 → 标准语言代码 */
const SUBTITLE_LANGUAGE_CODE_ALIASES = {
  en: 'en_US',
  zh: 'zh_CN',
  ko: 'ko_KR',
  ja: 'ja_JP',
  es: 'es_ES',
  th: 'th_TH',
  id: 'id_ID',
  pt: 'pt_PT',
  tr: 'tr_TR',
  fr: 'fr_FR',
  ar: 'ar_AE',
  de: 'de_DE',
  vi: 'vi_VN'
}

function normalizeLanguageCode(raw) {
  if (raw == null || raw === '') return ''
  let text = String(raw).trim()
  if (!text) return ''
  text = text.replace(/-/g, '_')
  const direct = Object.keys(SUBTITLE_LANGUAGE_LABEL_MAP).find(
    (key) => key.toLowerCase() === text.toLowerCase()
  )
  if (direct) return direct
  const lower = text.toLowerCase()
  const aliasKey = lower.split('_')[0]
  if (SUBTITLE_LANGUAGE_CODE_ALIASES[aliasKey]) {
    return SUBTITLE_LANGUAGE_CODE_ALIASES[aliasKey]
  }
  return text
}

/**
 * 根据语言代码解析 Tab 中文文案
 * @param {string} languageCode 如 en_US、en
 * @returns {string} 中文名称；未命中映射时返回空字符串
 */
export function getSubtitleLanguageLabel(languageCode) {
  const normalized = normalizeLanguageCode(languageCode)
  if (!normalized) return ''
  if (SUBTITLE_LANGUAGE_LABEL_MAP[normalized]) {
    return SUBTITLE_LANGUAGE_LABEL_MAP[normalized]
  }
  const lower = normalized.toLowerCase()
  const hit = Object.keys(SUBTITLE_LANGUAGE_LABEL_MAP).find(
    (key) => key.toLowerCase() === lower
  )
  return hit ? SUBTITLE_LANGUAGE_LABEL_MAP[hit] : ''
}

/**
 * 预览字幕 Tab 展示名：优先语言代码映射，其次接口中文 languageName
 */
export function resolveSubtitleTabLabel(options) {
  const opts = options || {}
  const fromCode = getSubtitleLanguageLabel(opts.language)
  if (fromCode) return fromCode

  const languageName = (opts.languageName && String(opts.languageName).trim()) || ''
  if (languageName && /[\u4e00-\u9fff]/.test(languageName)) {
    return languageName
  }

  const trackLabel = (opts.trackLabel && String(opts.trackLabel).trim()) || ''
  if (trackLabel && /[\u4e00-\u9fff]/.test(trackLabel)) {
    return trackLabel
  }

  return '——'
}
